import React from "react"
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import { ColumnFilter } from "../functions/ColumnFilter";
import { SelectColumnFilter } from "../functions/SelectColumnFilter";
import "react-datepicker/dist/react-datepicker.css";


export const COLUMNS = (props) => [
    {
        Header: 'Id',
        accessor: '_id',
        Filter: ColumnFilter,
        Cell: ({value}) => <a href={`javascript:void(0)`} style={{
            color:"#007bff"
        }} onClick={()=>props.history.push(`/admin/transactions/detail/${value}`)}>{value}</a>
    },
    {
        Header: 'Price',
        accessor: 'price',
        Filter: ColumnFilter,
        Cell: ({value}) => String(value+' $')
    },
    {
        Header: 'Note',
        accessor: 'description',
        Filter: ColumnFilter,
        Cell: ({value}) => String(value) || '-'
    },
    {
        Header: 'Buyer',
        accessor: 'buyer',
        filter : (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValueUsername = row.values.buyer.username || ""
                const rowValueEmail = row.values.buyer.email || ""
                return rowValueUsername.includes(filterValue) || rowValueEmail.includes(filterValue)
              })
        },
        Filter: (props) => ColumnFilter({...props,placeholder: "Search..."}),
        Cell: ({value}) => {
            return <div>
            <div>
            {value.email || ""}
            </div>
            <div>
            name: {value.username || ""}
            </div>
        </div>
        }
    },

    {
        Header: 'Seller',
        accessor: 'seller',
        Filter: ColumnFilter,
        filter : (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValueUsername = row.values.seller.username || ""
                const rowValueEmail = row.values.seller.email || ""
                return rowValueUsername.includes(filterValue) || rowValueEmail.includes(filterValue)
              })
        },
        Cell: ({value}) => {
            return <div>
            <div>
            {value.email || ""}
            </div>
            <div>
            name: {value.username || ""}
            </div>
        </div>
        }
    },

    {
        Header: 'Rating',
        accessor: 'rating',
        Filter: ColumnFilter,
        Cell: ({value}) => String(value) || '-'
    },
    {
        Header: 'Payment Type',
        accessor: 'payment_type',
        Filter: SelectColumnFilter,
        Cell: ({value}) => String(value) || '-'
    },
    {
        Header: 'Status',
        accessor: 'status_text',
        Filter: SelectColumnFilter,
    },
    {
        Header: 'Created Date',
        accessor: row => dayjs(row.created_at).format('DD/MM/YYYY'),
        // Filter:  <DatePicker  onChange={ColumnFilter} />,
    },
]


// WEBPACK FOOTER //
// ./client/react/Admin/data/column.js